/**
 * Fecha estimada de entrega.
 *
 * Se calcula aquí y no en Liquid porque la página se guarda en caché: una
 * fecha renderizada en el servidor se queda pegada y pasada la medianoche
 * estaría prometiendo un día que ya pasó.
 *
 * La cuenta es: hoy + días de preparación + días de transporte, saltando
 * sábados y domingos. Los festivos no se pueden saber desde aquí, por eso el
 * texto dice «días hábiles» y no promete un día exacto.
 */
(() => {
  const SELECTOR = '[data-ec-entrega]';

  const ES = {
    entre: (a, b) => `Llega entre el <strong>${a}</strong> y el <strong>${b}</strong>`,
    uno: (a) => `Llega el <strong>${a}</strong>`,
  };

  const EN = {
    entre: (a, b) => `Arrives between <strong>${a}</strong> and <strong>${b}</strong>`,
    uno: (a) => `Arrives <strong>${a}</strong>`,
  };

  /** Fecha de hoy según la tienda, con el reloj del visitante como suelo. */
  const arranque = (hoyTienda) => {
    const local = new Date();
    const propio = new Date(local.getFullYear(), local.getMonth(), local.getDate());

    const partes = String(hoyTienda || '').split('-').map(Number);
    if (partes.length !== 3 || partes.some(Number.isNaN)) return propio;

    const tienda = new Date(partes[0], partes[1] - 1, partes[2]);
    return tienda > propio ? tienda : propio;
  };

  const sumarHabiles = (desde, dias) => {
    const d = new Date(desde.getTime());
    let puestos = 0;
    let vueltas = 0;

    while (puestos < dias && vueltas < 400) {
      d.setDate(d.getDate() + 1);
      vueltas += 1;
      const dia = d.getDay();
      if (dia !== 0 && dia !== 6) puestos += 1;
    }

    return d;
  };

  const formatear = (fecha, idioma) => {
    try {
      return new Intl.DateTimeFormat(idioma, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      })
        .format(fecha)
        // Intl devuelve «mar, 29 sept»; dentro de «Llega entre el ... y el ...»
        // la coma sobra y el punto de la abreviatura también.
        .replace(/[.,]/g, '');
    } catch (_error) {
      return fecha.toLocaleDateString();
    }
  };

  const pintar = (caja) => {
    if (caja.dataset.ecEntregaLista === 'true') return;

    const linea = caja.querySelector('[data-ec-entrega-linea]');
    if (!linea) return;

    const min = parseInt(caja.dataset.min, 10);
    const max = parseInt(caja.dataset.max, 10);
    const preparacion = parseInt(caja.dataset.preparacion, 10);
    if (!Number.isFinite(min) || !Number.isFinite(max) || min < 1) return;

    const idioma = caja.dataset.idioma === 'en' ? 'en' : 'es';
    const textos = idioma === 'en' ? EN : ES;

    // Primero sale de la bodega, y desde ahí se cuenta el transporte.
    const despacho = sumarHabiles(
      arranque(caja.dataset.hoy),
      Number.isFinite(preparacion) ? preparacion : 1
    );
    const pronto = formatear(sumarHabiles(despacho, min), idioma);
    const tarde = formatear(sumarHabiles(despacho, max), idioma);

    linea.innerHTML = pronto === tarde ? textos.uno(pronto) : textos.entre(pronto, tarde);
    caja.dataset.ecEntregaLista = 'true';
  };

  const init = (raiz = document) => {
    raiz.querySelectorAll(SELECTOR).forEach(pintar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // El carrito y el selector de talla vuelven a dibujar su trozo de página.
  document.addEventListener('shopify:section:load', (evento) => init(evento.target));
  new MutationObserver((cambios) => {
    cambios.forEach((c) => {
      c.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(SELECTOR)) pintar(n);
        else if (n.querySelectorAll) init(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
